import Loader from 'components/Loader'
import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router'
import CuponesAutoservicio from './CuponesAutoservicio/CuponesAutoservicio'

const Autoservicio = ({ match }: any) => {
     return (
          <div className='app-wrapper'>
               <Switch>
                    <Suspense fallback={<Loader />}>
                         <Route path={`${match.url}/cupones`} component={CuponesAutoservicio} />
                    </Suspense>
               </Switch>
          </div>
     )
}

export default Autoservicio